export default {
  SET_GRID_DATA_GRID_EXMPL(state, params) {
    console.log(params);
    state.gridData = params;
  },

  SET_PROJECT_LIST_GRID_EXMPL(state, params) {
    state.projectList = params;
  },

  SET_COLUMN_HEADER_LIST_GRID_EXMPL(state, params) {
    state.columnHeaderList = params;
  },

  SET_COLUMN_NAME_LIST_GRID_EXMPL(state, params) {
    state.columnNameList = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridExmpl/gridExmplMutation.js